import BaseState from '@state/BaseState'
import GameStatesEnum from "@/states/GameStatesEnum";
import { Signals } from "@/Imports";
import Facade from "@/Facade";


export default class PreSpinStartState extends BaseState {
  begin() {
    /*if(this.model.isFreespinsMode) {
      this.end ()
      return
    } else  {
      if(this.model.balance >= this.model.totalBet) {
        this.end ()
      } else {
        Signals.notEnoughMoney.dispatch ()
        if (this.model.isAuto) {
          Signals.stopAutoplay.dispatch (true)
        }
        this.stateMachine.setState(GameStatesEnum.IDLE)
      }
    }*/

    this.end ()

  }

  end = () => {
    Facade.model.session_total_bet += this.model.totalBetNumber
    this.stateMachine.setState(GameStatesEnum.SPIN_START)
  }
}
